export default __webpack_public_path__ + "static/media/download.739372be.svg";